<script setup lang="ts">
import { $ti } from '@/locize';
import type { Race } from '@/objects/generated';

const props = defineProps<{
    race: Race;
}>();
</script>
<template>
    <span
        class="badge cursor-help border"
        :class="{
            'bg-light text-dark': true,
            'opacity-50': race.HideFromLive,
        }"
        :title="
            $ti('dashboard.racetitle', {
                name: race.Name,
                public: !race.HideFromLive ? $tm('general.yes') : $tm('general.no'),
            })
        "
        >{{ race.Name }}</span
    >
</template>
